export class CountryVpgaModel {
    id: number;
    country_id: number;
    vpga: string;
}